import type { FC } from 'react'

import Image from 'next/image'

import { CircularProgress } from '@/components/ui/circular-progress'

interface LoaderProps {
  logoIcon: string | null
}

export const Loader: FC<LoaderProps> = ({ logoIcon }) => {
  return (
    <div className="relative flex items-center justify-center">
      {logoIcon ? (
        <>
          <span className="z-10 flex h-[78px] w-[78px] items-center justify-center rounded-full bg-gray-300/60">
            <Image
              src={logoIcon}
              width={50}
              height={50}
              alt="loading"
              className="object-contain"
            />
          </span>

          <CircularProgress
            size={88}
            thickness={4}
            className="text-primary absolute -top-[5px] -left-[5px]"
          />
        </>
      ) : (
        <div className="flex flex-col items-center justify-center">
          <CircularProgress
            size={30}
            thickness={3}
            className="ml-3 text-white"
          />
          <p className="text-gray-300">
            Estamos preparando tudo para você, aguarde...
          </p>
        </div>
      )}
    </div>
  )
}
